import { useState, useEffect } from 'preact/hooks'
import { SearchspringProduct } from 'libs/searchspring/fetchers/product'
import { normaliseResults } from 'libs/searchspring/helpers/normalisers'

export function useSwatchImage(handle) {
  const [imageUrl, setImageUrl] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!handle) return

    const controller = new AbortController()
    fetchProductImage()

    async function fetchProductImage() {
      try {
        setIsLoading(true)
        const fetcher = new SearchspringProduct()
        fetcher.updateParams({ handle })
        const data = await fetcher.fetch(controller)

        if (controller.signal.aborted) return

        if (data.results && data.results.length > 0) {
          const normalised = await normaliseResults(data.results)
          if (normalised && normalised.length > 0 && normalised[0].images && normalised[0].images.length > 0) {
            setImageUrl(normalised[0].images[0].src)
          }
        }
        setIsLoading(false)
      } catch (error) {
        if (controller.signal.aborted || error.name === 'AbortError') return
        setIsLoading(false)
      }
    }

    return () => {
      controller.abort()
    }
  }, [handle])

  return { imageUrl, isLoading }
}
